import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import DisplayText from '../../common/text/DisplayText';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

export default ({
  typeId,
  isDisplay,
  onCheckChange: onPropCheckChange,
  value: {
    collect: checked,
  } = {},
}) => {
  // TODO: Get recent number not anchor
  const {
    [typeId]: anchorNumber,
  } = useSelector((state) => {
    const {
      settings: {
        company: {
          settings: {
            formAnchors = {},
          } = {},
        } = {},
      } = {},
    } = state;
    return formAnchors;
  });

  if(isDisplay && !checked) return null;
  return (
    <Row className='form-default-data-row' justify='space-between'>
      <Col>
        <Row gutter={10}>
          {!isDisplay && (
            <Col>
              <OnTraccrCheckbox
                onChange={onPropCheckChange}
                value={checked}
                label='Add Number'
              />
            </Col>
          )}
          {!!isDisplay && (
            <Col>
              Add Number
            </Col>
          )}
        </Row>
      </Col>
      {!isDisplay && checked && <Col>
        <DisplayText title={anchorNumber}/>
      </Col>}
    </Row>
  );
}
